import {join} from '@esgi/ui-kit/utils';

interface Props {
	className?: string;
	fill?: string;
}

export function StudentIcon({className, fill = '#BDBDBD'}: Props) {
	return <svg data-cy={'student-icon'} className={join(className)} width='35' height='38' viewBox='0 0 35 38'
	            xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M33.9635 36.989H1.39602C1.63116 27.0108 8.88342 19.1006 17.6798 19.1006C26.4761 19.1006 33.7284 27.0108 33.9635 36.989Z'
			fill='#BDBDBD'
			stroke='white'
		/>
		<circle cx='17.6798' cy='12.3044' r='10.4935' fill={fill} stroke='white' strokeWidth='2'/>
	</svg>;
}
